import { useState, useCallback } from 'react';
import { Table, TableFilters, TableStats, TableFormData } from '../types';
import { mockTables, mockTableStats } from '../mocks/tables';

export const useTables = () => {
  const [tables] = useState<Table[]>(mockTables);
  const [stats] = useState<TableStats>(mockTableStats);
  const [loading] = useState(false);
  const [error] = useState<string | null>(null);
  const [filters, setFilters] = useState<TableFilters>({
    status: 'all',
    capacity: 'all',
    search: ''
  });

  const createTable = useCallback(async (data: TableFormData) => {
    // Implementación futura
    console.log('Creating table:', data);
  }, []);

  const updateTable = useCallback(async (id: string, data: Partial<TableFormData>) => {
    // Implementación futura
    console.log('Updating table:', id, data);
  }, []);

  const deleteTable = useCallback(async (id: string) => {
    // Implementación futura
    console.log('Deleting table:', id);
  }, []);

  const updateTableStatus = useCallback(async (id: string, status: Table['status']) => {
    // Implementación futura
    console.log('Updating table status:', id, status);
  }, []);

  return {
    tables,
    stats,
    loading,
    error,
    filters,
    setFilters,
    createTable,
    updateTable,
    deleteTable,
    updateTableStatus
  };
};